import { mapGetters } from 'vuex';

import ContentBlockDescription from '@/components/custom/ContentBlock/ContentBlockDescription/index.vue';

export default {
  name: 'ContentBlockImageSide',
  components: { ContentBlockDescription },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    isImageRight: {
      type: Boolean,
      default: false
    },
    isBigTitles: {
      type: Boolean,
      default: false
    },
    isCropImg: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated'
    })
  },
  methods: {
    onHandleClick(buttonLink) {
      if (buttonLink === '@register') {
        this.showPopup();
        return;
      }

      window.open(buttonLink, '_blank');
    },
    showPopup() {
      if (!this.isAuthenticated) {
        this.changeLoginPopup(true);
      }
    }
  }
};
